import { makeAutoObservable } from "mobx";
import { randmarApiWithTags } from "randmar-api-client";
import { store } from "../../new-store/store";
import Job from "./Job";

class JobsStore {
  jobs: Job[] = [];
  isLoading = false;

  constructor() {
    makeAutoObservable(this);
  }

  async getJobs(applicationId: string) {
    this.isLoading = true;
    try {
      const jobs = await store.dispatch(
        randmarApiWithTags.endpoints.getV4PartnerByRouteApplicationIdJobs.initiate({
          routeApplicationId: applicationId,
        })
      ).unwrap();
      const mappedJobs = jobs.map(Job.convertFrom);

      this.jobs = mappedJobs;
    } catch (e) {
      console.error(e);
      this.jobs = [];
    } finally {
      this.isLoading = false;
    }
  }
}

export default JobsStore;
